import { KcUnifiedAuth } from '@tecsinapse-org/keycloak-unified-authentication'

const unified = new KcUnifiedAuth({
  keyCloakURL: import.meta.env.VITE_AUTH_URL,
  realmDiscoveryServiceURL: import.meta.env.VITE_DISCOVERY_URL,
  realmDiscoveryServiceApiKey: import.meta.env.VITE_DISCOVERY_KEY,
  redirectUri: location.origin,
  filterRedirect: true
})

export const getKeycloak = async (email: string) => {
  return await unified.discoverKeyCloakRealm(email, 'Portal')
}

export const inferRealm = async () => {
  return await unified.inferRealm()
}
